import React, { useState } from "react";
import { Tag, DatePicker, Select } from "antd";
import moment, { Moment } from "moment";
import * as R from "ramda";
import "./index.scss";
import { CalendarOutlined } from "@ant-design/icons";

type Props = {
  value?: number[];
  onChange?: any;
  onClear?: () => void;
  format?: string;
  selectProps?: any; // You can replace `any` with the appropriate type
  datePickerProps?: any; // You can replace `any` with the appropriate type
  isClass?: any
}

const getTimestamp = (value: Moment) => value.startOf("day").valueOf()

const MultipleDatePicker: React.FC<Props> = ({
  value: selectedDates = [],
  onChange,
  onClear,
  format = "YYYY-MM-DD",
  selectProps = {},
  datePickerProps = {},
  isClass
}) => {
  const [open, setOpen] = useState(false);

  const onValueChange = (date: Moment) => {
    const time = getTimestamp(date);
    let newSelectedDates = [...selectedDates];
  
    if (selectedDates.includes(time)) {
      newSelectedDates = newSelectedDates.filter(item => item !== time);
    } else {
      newSelectedDates.push(time);
    }
  
    onChange?.(newSelectedDates, time);
  };


  // React.useEffect(() => {
  //   return () => {
  //     submit && submit(selectedDate)
  //   }
  // }, [])

  const dateRender = (currentDate: Moment) => {
    const isSelected = selectedDates.indexOf(getTimestamp(currentDate)) > -1;
    return (
      <div
        className={"ant-picker-cell-inner"}
        style={
          isSelected
            ? {
              position: "relative",
              zIndex: 2,
              display: "inlineBlock",
              width: "24px",
              height: "22px",
              lineHeight: "22px",
              backgroundColor: "#EE0033",
              color: "#fff",
              margin: "auto",
              borderRadius: "px",
              transition: "background 0.3s, border 0.3s"
            }
            : {}
        }
      >
        {currentDate.date()}
      </div>
    );
  };

  const renderTag = ({ value, onClose }: { value: number; onClose: () => void }) => {
    const handleClose = () => {
      onClose();
      onChange && onChange(selectedDates.filter((time) => time !== value));
    };
    return (
      <Tag key={value} onClose={handleClose} closable>
        {moment(value).format(format)}
      </Tag>
    );
  };

  // React.useEffect(() => {
  //   setFirstLoad(prev => prev+1);
  //   if (weekend?.length) {
  //     if (!checked && selectedDate?.length) {
  //       onChange(selectedDate.filter((item: number) => !listWeekend().includes(item)))
  //     } else {
  //       if (checked && firstLoad>0) {
  //         onChange(selectedDate?.concat(listWeekend()))
  //       }

  //     }
  //   }
  // }, [checked])


  React.useEffect(() => {
    console.log("selectedDates", selectedDates)
  }, [selectedDates])

  return (
    <Select
      showSearch={false}
      className="!w-full !rounded-[8px]"
      allowClear
      placeholder={isClass =='whitelist' ? "Chọn ngày cho phép đặt cơm": 'Chọn ngày lễ'}
      {...selectProps}
      mode="multiple"
      value={selectedDates}
      // defaultValue={selectedWeekend}
      onClear={() => {
        onClear!()
      }}
      tagRender={renderTag}
      open={open}
      onFocus={() => { setOpen(true); }}
      onBlur={() => { setOpen(false); }}
      suffixIcon={<CalendarOutlined />}
      dropdownMatchSelectWidth={false}
      popupClassName={isClass == 'whitelist' ? "multipleDropdownClassName1" : "multipleDropdownClassName"}
      dropdownStyle={{ height: "260px", width: "280px", minWidth: "0" }}
      dropdownRender={() => {
        return (
          (open ) ?
            <DatePicker
              {...datePickerProps}
              format={(value) => ""}
              onChange={onValueChange}
              value={null}
              showToday={false}
              open={open}
              onBlur={() => setOpen(false)}
              dateRender={dateRender}
              style={{ ...datePickerProps.style, visibility: "hidden" }}
              getPopupContainer={() => (
                isClass == 'whitelist' ? 
                  document.getElementsByClassName("multipleDropdownClassName1")[0] ? document.getElementsByClassName("multipleDropdownClassName1")[0] : ''
                : 
                  document.getElementsByClassName("multipleDropdownClassName")[0] ? document.getElementsByClassName("multipleDropdownClassName")[0] : ''
              )
              }
            /> : <></>
        );
      }}
    />
  );
}

export default MultipleDatePicker
